import { html } from 'lit';

export const iconPencil = html`
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.92824 0.513251C10.6126 -0.171084 11.7239 -0.171084 12.4082 0.513251L13.4868 1.59267C14.1711 2.27678 14.1711 3.38714 13.4868 4.07153L12.1619 5.3965L8.60338 1.83823L9.92824 0.513251ZM11.5433 6.01519L5.15984 12.3964C4.87515 12.6811 4.52204 12.8919 4.13608 13.0042L0.842266 13.9733C0.611784 14.0417 0.362415 13.9787 0.192427 13.7844C0.0224343 13.6393 -0.0411207 13.3902 0.02671 13.1575L0.995556 9.86419C1.10943 9.4782 1.31829 9.12505 1.60324 8.84035L7.98475 2.45746L11.5433 6.01519Z"
      fill="currentColor"
    />
  </svg>
`;
